import { Component, Input } from '@angular/core';
import { SubscriptionService } from '../../../../../../../../../../SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/subscription/services/subscription.service';

@Component({
  standalone: false,
  selector: 'suvo-bi-billing-details',
  templateUrl: './billing-details.component.html',
  styleUrls: ['./billing-details.component.scss'],
})
export class BillingDetailsComponent {
  @Input() selectedOrganisation;

  constructor(private subscriptionService: SubscriptionService) {}

  async goToCustomerPortal() {
    try {
      const newPortalSession = await this.subscriptionService.createCustomerPortalSession(
        this.selectedOrganisation.organisationId,
        'personal',
      );
      if (newPortalSession) {
        window.location.href = newPortalSession.url;
      }
      console.log(newPortalSession);
    } catch (error) {
      console.log(error);
    }
  }
}
